import { defineComponent as i, toRefs as m, ref as p, computed as y, openBlock as w, createBlock as C, resolveDynamicComponent as b, normalizeClass as v, withKeys as k, withCtx as g, renderSlot as V, createCommentVNode as h } from "vue";
import { onClickOutside as B } from "@vueuse/core";
import { SfDrawerPlacement as e } from "@storefront-ui/shared";
const K = /* @__PURE__ */ i({
  __name: "SfDrawer",
  props: {
    modelValue: {
      type: Boolean,
      default: !1
    },
    placement: {
      type: String,
      default: e.left
    },
    tag: {
      type: [String, Object],
      default: "aside"
    },
    disableClickAway: {
      type: Boolean,
      default: !1
    },
    disableEsc: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:modelValue"],
  setup(a, { emit: s }) {
    const r = a, { disableClickAway: n, disableEsc: d, placement: t } = m(r), l = s, o = p();
    B(o, () => {
      n.value || l("update:modelValue", !1);
    });
    const f = () => {
      d.value || l("update:modelValue", !1);
    }, u = y(() => ({
      "left-0": t.value !== e.right,
      "right-0": t.value !== e.left,
      "top-0": t.value !== e.bottom,
      "bottom-0": t.value !== e.top
    }));
    return (c, S) => a.modelValue ? (w(), C(b(a.tag), {
      key: 0,
      ref_key: "drawerRef",
      ref: o,
      class: v(["fixed", u.value]),
      "data-testid": "drawer",
      tabindex: "-1",
      onKeydown: k(f, ["esc"])
    }, {
      default: g(() => [
        V(c.$slots, "default")
      ]),
      _: 3
    }, 40, ["class"])) : h("", !0);
  }
});
export {
  K as default
};
